import React from 'react'
import { useFeatureFlags } from 'hooks/useFeatureFlags'
import { GoogleOAuthProvider } from 'react-oauth-google'

export const GoogleAuthWrapper = ({ children }) => {
  const { REACT_APP_GOOGLE_OAUTH_CLIENT_ID } = process.env
  const { IS_HOSPITAL } = useFeatureFlags()

  return !IS_HOSPITAL ? (
    <GoogleOAuthProvider clientId={REACT_APP_GOOGLE_OAUTH_CLIENT_ID || 'no-id'}>
      {children}
    </GoogleOAuthProvider>
  ) : (
    <>{children}</>
  )
}
